import React from "react";
import { HandshakeIcon } from "../HandshakeIcon";
import { Flag, TOUR_CURRENCIES, TOUR_LABELS, fmtFans } from "../../lib/tour";
import { useGainPop } from "../../lib/useGainPop";

const CHIP = "relative flex items-center rounded-full bg-[#0A051A]/75 backdrop-blur-md border border-[#00F0FF]/30 font-mono shadow-[0_0_10px_rgba(0,240,255,0.15)]";
const SIZE = { fixed: "gap-1.5 px-2.5 py-1 text-xs", fluid: "gap-[0.5em] px-[0.8em] py-[0.3em] leading-tight" };

function GainChip({ title, testId, value, color, min, fmt, size, children }) {
  const pop = useGainPop(value, { min });
  return (
    <div key={pop?.key} title={title} data-testid={testId} className={`${CHIP} ${size} ${pop ? "cur-pop" : ""}`} style={{ "--c": color }}>
      {children}
      {pop && (
        <span data-testid={`${testId}-gain`} className="cur-gain absolute left-1/2 top-full mt-0.5 font-num text-sm whitespace-nowrap pointer-events-none z-50"
              style={{ color, textShadow: `0 0 8px ${color}, 1px 1px 0 #000` }}>
          +{fmt(pop.diff)}
        </span>
      )}
    </div>
  );
}

export function TourCurrencyStrip({ fans, handshakes, prefix = "tour", className = "", fluid = false, style }) {
  const size = fluid ? SIZE.fluid : SIZE.fixed;
  return (
    <div className={`flex flex-wrap justify-center ${fluid ? "" : "gap-1.5"} ${className}`} style={style} data-testid={`${prefix}-currencies`}>
      {TOUR_CURRENCIES.map((c) => (
        <GainChip key={c} title={TOUR_LABELS[c]} testId={`${prefix}-fans-${c}`} value={fans[c] || 0} color="#39FF14" min={1} fmt={fmtFans} size={size}>
          <Flag c={c} className={fluid ? "w-[1.6em] h-[1.1em]" : "w-5 h-3.5"} /> <span className="text-white">{fmtFans(fans[c])}</span>
        </GainChip>
      ))}
      <GainChip title="Handshakes" testId={`${prefix}-handshakes`} value={handshakes || 0} color="#00F0FF" min={1} fmt={(v) => v.toLocaleString()} size={size}>
        <HandshakeIcon className={fluid ? "w-[1.3em] h-[1.3em]" : "w-4 h-4"} /> <span className="text-white">{(handshakes || 0).toLocaleString()}</span>
      </GainChip>
    </div>
  );
}
